import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import TestingAccountFilter from "../../Common/TestingAccountFilter";

const DEFAULT_FILTERS = {
  customer_status: "",
  onboarding: "",
  phase2_status: "",
  created_start_date: "",
  created_end_date: "",
  last_login_start_date: "",
  last_login_end_date: "",
  has_membership: "",
  membership_status: "",
  membership_id: "",
  membership_term: "",
  purchase_source: "",
  membership_start_date: "",
  membership_end_date: "",
  membership_expiry_window_days: "",
  invoice_type: "",
  usage_state: "",
  testing_account_filter: "hide",
  sort_by: "created_on",
  sort_order: "desc",
};

const Customer360Filter = ({ modal, setModal, params, setParams }) => {
  const [localFilters, setLocalFilters] = useState(DEFAULT_FILTERS);

  useEffect(() => {
    if (modal) {
      setLocalFilters({
        customer_status: params.customer_status || "",
        onboarding: params.onboarding || "",
        phase2_status: params.phase2_status || "",
        created_start_date: params.created_start_date || "",
        created_end_date: params.created_end_date || "",
        last_login_start_date: params.last_login_start_date || "",
        last_login_end_date: params.last_login_end_date || "",
        has_membership: params.has_membership || "",
        membership_status: params.membership_status || "",
        membership_id: params.membership_id || "",
        membership_term: params.membership_term || "",
        purchase_source: params.purchase_source || "",
        membership_start_date: params.membership_start_date || "",
        membership_end_date: params.membership_end_date || "",
        membership_expiry_window_days: params.membership_expiry_window_days || "",
        invoice_type: params.invoice_type || "",
        usage_state: params.usage_state || "",
        testing_account_filter: params.testing_account_filter || "hide",
        sort_by: params.sort_by || "created_on",
        sort_order: params.sort_order || "desc",
      });
    }
  }, [modal, params]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setLocalFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleApplyFilter = () => {
    setParams((prevParams) => ({
      ...prevParams,
      ...localFilters,
      page: 1,
    }));
    setModal(false);
  };

  const handleClearFilters = () => {
    setLocalFilters(DEFAULT_FILTERS);
    setParams((prevParams) => ({
      ...prevParams,
      ...DEFAULT_FILTERS,
      page: 1,
    }));
    setModal(false);
  };

  return (
    <Modal
      className="filter-modal customer360-filter-modal"
      isOpen={modal}
      toggle={() => setModal((state) => !state)}
      centered
      size="lg"
    >
      <ModalHeader toggle={() => setModal((state) => !state)}>
        Customer 360 Filters
      </ModalHeader>
      <ModalBody>
        <div className="customer360-filter-section">
          <h6>Customer</h6>
          <div className="row">
            <div className="col-md-4 form-group">
              <label>Customer Status</label>
              <select
                className="form-control"
                name="customer_status"
                value={localFilters.customer_status}
                onChange={handleInputChange}
              >
                <option value="">All</option>
                <option value="1">Active</option>
                <option value="2">Inactive</option>
                <option value="3">Blocked</option>
              </select>
            </div>
            <div className="col-md-4 form-group">
              <label>Phase 2 Status</label>
              <select
                className="form-control"
                name="phase2_status"
                value={localFilters.phase2_status}
                onChange={handleInputChange}
              >
                <option value="">All</option>
                <option value="integrated">Phase 2</option>
                <option value="in_progress">In Progress</option>
                <option value="not_started">Not Started</option>
              </select>
            </div>
            <div className="col-md-4 form-group">
              <label>Has Membership</label>
              <select
                className="form-control"
                name="has_membership"
                value={localFilters.has_membership}
                onChange={handleInputChange}
              >
                <option value="">All</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <TestingAccountFilter
              className="col-md-4 form-group"
              value={localFilters.testing_account_filter}
              onChange={handleInputChange}
            />
            <div className="col-md-3 form-group">
              <label>Created From</label>
              <input
                type="date"
                className="form-control"
                name="created_start_date"
                value={localFilters.created_start_date}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3 form-group">
              <label>Created To</label>
              <input
                type="date"
                className="form-control"
                name="created_end_date"
                value={localFilters.created_end_date}
                onChange={handleInputChange}
                min={localFilters.created_start_date || undefined}
              />
            </div>
            <div className="col-md-3 form-group">
              <label>Last Login From</label>
              <input
                type="date"
                className="form-control"
                name="last_login_start_date"
                value={localFilters.last_login_start_date}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3 form-group">
              <label>Last Login To</label>
              <input
                type="date"
                className="form-control"
                name="last_login_end_date"
                value={localFilters.last_login_end_date}
                onChange={handleInputChange}
                min={localFilters.last_login_start_date || undefined}
              />
            </div>
          </div>
        </div>

        <div className="customer360-filter-section">
          <h6>Membership</h6>
          <div className="row">
            <div className="col-md-3 form-group">
              <label>Membership Status</label>
              <select
                className="form-control"
                name="membership_status"
                value={localFilters.membership_status}
                onChange={handleInputChange}
              >
                <option value="">All</option>
                <option value="0">Pending</option>
                <option value="1">Active</option>
                <option value="2">Expired</option>
              </select>
            </div>
            <div className="col-md-3 form-group">
              <label>Membership ID</label>
              <input
                type="number"
                className="form-control"
                name="membership_id"
                value={localFilters.membership_id}
                onChange={handleInputChange}
                placeholder="Exact ID"
              />
            </div>
            <div className="col-md-3 form-group">
              <label>Membership Term</label>
              <select
                className="form-control"
                name="membership_term"
                value={localFilters.membership_term}
                onChange={handleInputChange}
              >
                <option value="">All</option>
                <option value="monthly">Monthly</option>
                <option value="semi_annual">Semi-Annual</option>
                <option value="annual">Annual</option>
                <option value="days">Days</option>
              </select>
            </div>
            <div className="col-md-3 form-group">
              <label>Purchase Source</label>
              <select
                className="form-control"
                name="purchase_source"
                value={localFilters.purchase_source}
                onChange={handleInputChange}
              >
                <option value="">All</option>
                <option value="admin">Admin</option>
                <option value="website">Website</option>
                <option value="shopify">Shopify</option>
                <option value="wordpress">WordPress</option>
                <option value="unknown">Unknown</option>
              </select>
            </div>
            <div className="col-md-3 form-group">
              <label>Membership Start Date</label>
              <input
                type="date"
                className="form-control"
                name="membership_start_date"
                value={localFilters.membership_start_date}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3 form-group">
              <label>Membership End Date</label>
              <input
                type="date"
                className="form-control"
                name="membership_end_date"
                value={localFilters.membership_end_date}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3 form-group">
              <label>Expiry in Next (Days)</label>
              <input
                type="number"
                min="0"
                className="form-control"
                name="membership_expiry_window_days"
                value={localFilters.membership_expiry_window_days}
                onChange={handleInputChange}
                placeholder="e.g. 30"
              />
            </div>
          </div>
        </div>

        <div className="customer360-filter-section">
          <h6>Usage + Sorting</h6>
          <div className="row">
            <div className="col-md-3 form-group">
              <label>Invoice Type</label>
              <select
                className="form-control"
                name="invoice_type"
                value={localFilters.invoice_type}
                onChange={handleInputChange}
              >
                <option value="">All</option>
                <option value="simplified">Simplified</option>
                <option value="vat">VAT</option>
                <option value="purchase">Purchase</option>
                <option value="credit">Credit</option>
                <option value="debit">Debit</option>
              </select>
            </div>
            <div className="col-md-3 form-group">
              <label>Usage State</label>
              <select
                className="form-control"
                name="usage_state"
                value={localFilters.usage_state}
                onChange={handleInputChange}
              >
                <option value="">All</option>
                <option value="available">Available</option>
                <option value="exhausted">Exhausted</option>
              </select>
            </div>
            <div className="col-md-3 form-group">
              <label>Sort By</label>
              <select
                className="form-control"
                name="sort_by"
                value={localFilters.sort_by}
                onChange={handleInputChange}
              >
                <option value="created_on">Created On</option>
                <option value="user_id">User ID</option>
                <option value="company_name">Company</option>
                <option value="first_name">First Name</option>
                <option value="last_name">Last Name</option>
                <option value="last_login_date">Last Login</option>
                <option value="membership_start_date">Membership Start</option>
                <option value="membership_end_date">Membership End</option>
                <option value="membership_status">Membership Status</option>
                <option value="customer_status">Customer Status</option>
                <option value="phase2_status">Phase 2 Status</option>
              </select>
            </div>
            <div className="col-md-3 form-group">
              <label>Sort Order</label>
              <select
                className="form-control"
                name="sort_order"
                value={localFilters.sort_order}
                onChange={handleInputChange}
              >
                <option value="desc">Descending</option>
                <option value="asc">Ascending</option>
              </select>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <button className="buttons border-button" onClick={handleClearFilters}>
          <span>Reset Filters</span>
        </button>
        <button className="buttons background-button" onClick={handleApplyFilter}>
          <span>Apply Filters</span>
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default Customer360Filter;
